import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'barviewaccess',
  entityPlural: 'barviewaccess',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV
});
